<footer>
  <div class="config-unit-cr">
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      (click)="modalToUnLink = true"
    >
      <path
        d="M16.875 12C16.875 11.0358 16.5891 10.0933 16.0534 9.2916C15.5178 8.48991 14.7564 7.86507 13.8656 7.49609C12.9748 7.12712 11.9946 7.03058 11.0489 7.21868C10.1033 7.40678 9.23464 7.87108 8.55286 8.55286C7.87108 9.23464 7.40678 10.1033 7.21868 11.0489C7.03058 11.9946 7.12712 12.9748 7.4961 13.8656C7.86507 14.7564 8.48991 15.5177 9.2916 16.0534C10.0933 16.5891 11.0358 16.875 12 16.875C13.2925 16.8735 14.5316 16.3594 15.4455 15.4455C16.3594 14.5316 16.8735 13.2925 16.875 12ZM9.37501 12C9.37501 11.4808 9.52896 10.9733 9.8174 10.5416C10.1058 10.11 10.5158 9.7735 10.9955 9.57482C11.4751 9.37614 12.0029 9.32416 12.5121 9.42545C13.0213 9.52673 13.4891 9.77674 13.8562 10.1439C14.2233 10.511 14.4733 10.9787 14.5746 11.4879C14.6759 11.9971 14.6239 12.5249 14.4252 13.0046C14.2265 13.4842 13.8901 13.8942 13.4584 14.1826C13.0267 14.4711 12.5192 14.625 12 14.625C11.3038 14.625 10.6361 14.3484 10.1439 13.8562C9.65157 13.3639 9.37501 12.6962 9.37501 12ZM14.0222 22.6744C14.1807 22.6427 14.3304 22.5772 14.4613 22.4824C14.5922 22.3876 14.7011 22.2657 14.7806 22.125L16.2666 19.5197L19.2019 19.5094C19.3647 19.5088 19.5255 19.4729 19.6732 19.4041C19.8208 19.3353 19.9517 19.2353 20.0569 19.1109C20.9452 18.061 21.6263 16.8522 22.0641 15.5484C22.1142 15.3997 22.1327 15.2422 22.1184 15.0859C22.104 14.9296 22.0571 14.778 21.9806 14.6409L20.5059 12L21.9816 9.35907C22.0584 9.22182 22.1057 9.06997 22.1202 8.91333C22.1347 8.75669 22.1162 8.59875 22.0659 8.44969C21.6263 7.14559 20.9433 5.93672 20.0531 4.88719C19.9481 4.76326 19.8174 4.66356 19.6701 4.59494C19.5229 4.52632 19.3625 4.49042 19.2 4.48969L16.2619 4.47657L14.7797 1.87501C14.6999 1.7343 14.5906 1.61246 14.4594 1.51782C14.3282 1.42317 14.1781 1.35794 14.0194 1.32657C12.6852 1.06172 11.312 1.06172 9.97782 1.32657C9.81944 1.35819 9.66973 1.42354 9.53886 1.51817C9.40799 1.61281 9.29903 1.73451 9.21938 1.87501L7.73345 4.48313L4.79813 4.49344C4.63527 4.49401 4.47448 4.52993 4.32686 4.59872C4.17924 4.66752 4.04831 4.76754 3.94313 4.89188C3.05483 5.94178 2.37373 7.15065 1.93595 8.45438C1.88578 8.6031 1.86729 8.76067 1.88166 8.91696C1.89603 9.07325 1.94294 9.2248 2.01938 9.36188L3.49407 12L2.01845 14.6381C1.94158 14.7754 1.89436 14.9272 1.87983 15.0839C1.8653 15.2405 1.88377 15.3985 1.93407 15.5475C2.37367 16.8516 3.05669 18.0605 3.94688 19.11C4.05195 19.2339 4.18261 19.3336 4.32988 19.4023C4.47715 19.4709 4.63754 19.5068 4.80001 19.5075L7.73813 19.5206L9.22032 22.1278C9.30017 22.2685 9.40942 22.3904 9.54063 22.485C9.67184 22.5797 9.82192 22.6449 9.98063 22.6763C11.3149 22.9405 12.6881 22.9399 14.0222 22.6744ZM10.9116 20.5528L9.47907 18.0328C9.37757 17.8538 9.22868 17.7062 9.04876 17.6063C8.95501 17.5556 8.86782 17.5022 8.77876 17.4469C8.60137 17.3358 8.3965 17.2764 8.1872 17.2753L5.34376 17.2622C4.88736 16.6557 4.51318 15.9915 4.23095 15.2869L5.65501 12.7416C5.74901 12.5737 5.79839 12.3846 5.79845 12.1922V12.165C5.79845 12.0581 5.79845 11.9494 5.79845 11.8425C5.8032 11.6415 5.75434 11.4428 5.65688 11.2669L4.23563 8.71876C4.51647 8.01297 4.88905 7.34724 5.34376 6.73876L8.17876 6.72844C8.38839 6.72758 8.5936 6.66815 8.77126 6.55688C8.85938 6.50251 8.95032 6.44813 9.04126 6.39751C9.22008 6.2975 9.36797 6.15026 9.46876 5.97188L10.9097 3.45001C11.6326 3.35204 12.3655 3.35204 13.0884 3.45001L14.5209 5.97001C14.6224 6.14875 14.7709 6.29627 14.9503 6.39657C15.0441 6.44719 15.1322 6.50063 15.2213 6.55594C15.3986 6.66705 15.6035 6.72646 15.8128 6.72751L18.6563 6.73782C19.1113 7.34453 19.4843 8.00872 19.7653 8.71313L18.3413 11.2584C18.2426 11.4343 18.1934 11.6335 18.1988 11.835C18.1988 11.9419 18.1988 12.0506 18.1988 12.1575C18.194 12.3585 18.2429 12.5572 18.3403 12.7331L19.7644 15.2813C19.4835 15.987 19.111 16.6528 18.6563 17.2613L15.8213 17.2716C15.6116 17.2724 15.4064 17.3319 15.2288 17.4431C15.1406 17.4975 15.0497 17.5519 14.9588 17.6025C14.7799 17.7025 14.632 17.8498 14.5313 18.0281L13.0941 20.55C12.37 20.6493 11.6359 20.6502 10.9116 20.5528Z"
        fill="white"
      />
    </svg>

    <p class="unidade" *ngIf="unit">CR {{ unit.code }} - {{ unit.name }}</p>
  </div>

  <div class="config-unit-cr">
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <mask
        id="mask0_715_1859"
        style="mask-type: alpha"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="25"
        height="24"
      >
        <rect
          x="24.5"
          width="24"
          height="24"
          transform="rotate(90 24.5 0)"
          fill="#D9D9D9"
        />
      </mask>
      <g mask="url(#mask0_715_1859)">
        <path
          d="M11.5 11V5H13.5V11H19.5V13H13.5V19H11.5V13H5.5V11H11.5Z"
          fill="white"
        />
      </g>
    </svg>
    <p>{{ answers.length + answersNotSent.length }}</p>
  </div>

  <div class="config-unit-cr">
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.0459 11.296C19.9414 11.4009 19.8172 11.4841 19.6804 11.5409C19.5437 11.5976 19.3971 11.6269 19.249 11.6269C19.101 11.6269 18.9543 11.5976 18.8176 11.5409C18.6809 11.4841 18.5567 11.4009 18.4521 11.296L13.625 6.46879V20.25C13.625 20.5484 13.5064 20.8346 13.2955 21.0455C13.0845 21.2565 12.7983 21.375 12.5 21.375C12.2016 21.375 11.9154 21.2565 11.7045 21.0455C11.4935 20.8346 11.375 20.5484 11.375 20.25V6.46879L6.5459 11.296C6.33455 11.5073 6.04791 11.6261 5.74902 11.6261C5.45014 11.6261 5.16349 11.5073 4.95215 11.296C4.7408 11.0846 4.62207 10.798 4.62207 10.4991C4.62207 10.2002 4.7408 9.91357 4.95215 9.70223L11.7021 2.95223C11.8067 2.84735 11.9309 2.76413 12.0676 2.70735C12.2043 2.65057 12.351 2.62134 12.499 2.62134C12.6471 2.62134 12.7937 2.65057 12.9304 2.70735C13.0672 2.76413 13.1914 2.84735 13.2959 2.95223L20.0459 9.70223C20.1508 9.80674 20.234 9.93093 20.2908 10.0677C20.3476 10.2044 20.3768 10.351 20.3768 10.4991C20.3768 10.6472 20.3476 10.7938 20.2908 10.9305C20.234 11.0673 20.1508 11.1915 20.0459 11.296Z"
        fill="white"
      />
    </svg>

    <p>{{ answersSent.length }}</p>
  </div>

  <div class="config-unit-cr">
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.58301 12.1928C5.68753 12.0879 5.81172 12.0047 5.94846 11.9479C6.08521 11.8911 6.23182 11.8619 6.37988 11.8619C6.52795 11.8619 6.67456 11.8911 6.8113 11.9479C6.94805 12.0047 7.07224 12.0879 7.17676 12.1928L12.0039 17.02V3.23873C12.0039 2.94036 12.1225 2.65421 12.3335 2.44324C12.5444 2.23226 12.8306 2.11373 13.1289 2.11373C13.4273 2.11373 13.7135 2.23226 13.9244 2.44324C14.1354 2.65421 14.2539 2.94036 14.2539 3.23873V17.02L19.083 12.1928C19.2944 11.9814 19.581 11.8627 19.8799 11.8627C20.1788 11.8627 20.4654 11.9814 20.6768 12.1928C20.8881 12.4041 21.0068 12.6908 21.0068 12.9897C21.0068 13.2886 20.8881 13.5752 20.6768 13.7865L13.9268 20.5365C13.8222 20.6414 13.6981 20.7246 13.5613 20.7814C13.4246 20.8382 13.278 20.8674 13.1299 20.8674C12.9818 20.8674 12.8352 20.8382 12.6985 20.7814C12.5617 20.7246 12.4375 20.6414 12.333 20.5365L5.58301 13.7865C5.47813 13.682 5.39491 13.5578 5.33813 13.4211C5.28135 13.2843 5.25212 13.1377 5.25212 12.9897C5.25212 12.8416 5.28135 12.695 5.33813 12.5582C5.39491 12.4215 5.47813 12.2973 5.58301 12.1928Z"
        fill="white"
      />
    </svg>

    <p>{{ answersNotSent.length }}</p>
  </div>

  <div>
    <p *ngIf="hasNetwork; else offline">ONLINE</p>
    <ng-template #offline><p>OFFLINE</p></ng-template>
  </div>
</footer>
<div class="overlay" *ngIf="modalToUnLink">
  <div class="pass">
    <div class="content-pass">
      <p class="title">Informe a Senha</p>
      <p class="close" (click)="modalToUnLink = false">x</p>
    </div>

    <p class="device-title" *ngIf="unit">
      Nome do dispositivo: {{ unit.device.name }}
    </p>

    <input type="password" [formControl]="password" />
    <p class="error" *ngIf="password.touched && password.invalid">
      *Senha obrigatória!
    </p>

    <div class="content-pass btns">
      <button class="btn cancel" (click)="modalToUnLink = false">
        Cancelar
      </button>
      <button class="btn" (click)="unLinkDevice()">Confirmar</button>
    </div>
  </div>
</div>
